import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import * as mime from 'mime-types';
import React from 'react';
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import { LookUpTables } from '../../constants/LookUpTables';
import { getLookUpTable } from '../../networking/Networking';
import { getConfirmation, getDealHeaderInfo, getInwardConfirmation, sendDealReportByEmailForTraderScreen } from '../../networking/NetworkingDeals';
import { getPropertiesForDealHeader } from '../../networking/NetworkingEntityProperties';
import { getContactsByCustomer } from '../../networking/NetworkingContacts';
import { getCustomerByID } from '../../networking/NetworkingCustomers';
import { getStyle, notFilledInputClass, notFilledSelectClass, regularInputClass, regularSelectClass } from '../../styles/styles';
import { validateEmail2 } from '../../helpers/ValidateHelper'
import AlertBox from '../shared/AlertBox';
import DynamicSelect from '../shared/DynamicSelect';
import LoadingBox from '../shared/LoadingBox';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { CustomerType } from '../../constants/EntityTypeNames';
import { Divider } from 'antd';

let addPasswordToReports = (window.REACT_APP_ADD_PASSWORD_TO_REPORTS) ? window.REACT_APP_ADD_PASSWORD_TO_REPORTS : false;

var style = getStyle();

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });  

const DocumentTypes = {
    CONFIRMATION        : 'Confirmation',
    INWARD_CONFIRMATION  : 'InwardConfirmation',
    BOTH_CONFIRMATION   : 'Confirmation-InwardConfirmation'
}

export default class NewDealConfirmationFormDialog extends React.Component {

    state = {
        dealHeaderInfo: {},
        language: "",
        email: "",
        customerContactSelected: 0,
        additionalEmail: "",
        traderEmail: "",
        //
        dealHeaderId: 0,
        title: 'Print/Send Deal Confirmation',
        documentType: DocumentTypes.CONFIRMATION,
        //
        emailChecked: false,
        additionalEmailChecked: false,
        traderEmailChecked: false,
        InwardsFundsConfirmationChecked: false,
        DealConfirmationChecked: false,
        //
        emailDisabled: true,
        additionalEmailDisabled: true,
        traderEmailDisabled: true,
        //
        listLanguages: [],
        customerContactsList: [],
        //
        loading: false,
        //alert
        showAlert: false,
        alertMessage: '',
        alertTitle: '',
        messageList: [],
        //
        showAlertEmail: false,
        alertMessageEmail: '',
        alertTitleEmail: '',
        //
        //preview
        currentFileName         : '',
        currentFileURLList      : [],
        openPreviewFile         : false,
        currentInwardName         : '',
        currentInwardURLList      : [],
        openPreviewInward       : false,
        fullWidthPreviewFile    : true,
        maxWidthPreviewFile     : 'md',

        additionalMobileNumber  : '',

        validations: {
            language: true,
            email: true,
            additionalEmail: true,
            traderEmail: true,
            additionalMobileNumber: true
        },

        addPwdToReports         : false,
    }

    async componentDidUpdate(prevProps)
    {
        if(this.props !== prevProps)
        {
            if (this.props.lookUpTables != null && this.props.lookUpTables !== prevProps.lookUpTables) {
                this.setState({dealHeaderId: this.props.dealHeaderId},
                    () => {
                        let lookUpTables = this.props.lookUpTables
    
                        let languages = lookUpTables.filter(x => x.LookUpTableDescription === LookUpTables.Languages)[0];
    
                        languages.lookUpTableDetails.forEach(element => {
                            element.value = element.LookUpTableDetail;
                            element.name = element.LookUpTableDetail;
                        });
                        this.setState({listLanguages: languages.lookUpTableDetails})
                    })
            }
            if (this.props.dealHeaderInfo != null && this.props.dealHeaderInfo !== prevProps.dealHeaderInfo) {
                this.setState({dealHeaderInfo: this.props.dealHeaderInfo}, () => {
                    //default values:
                    this.setState({
                        email: this.state.dealHeaderInfo.Email,
                        emailChecked: this.state.dealHeaderInfo.EmailConfirmations,
                        language: this.state.dealHeaderInfo.PreferredLanguage,
                        emailDisabled: !this.stringEmptyOrNull(this.state.dealHeaderInfo.Email),
                        traderEmail: this.state.dealHeaderInfo.TraderEmail
                    }, () =>{
                        this.getCustomerContactList(this.props.dealHeaderInfo);
                    });
                })
            }
            if (this.props.dealHeaderId != null && this.props.dealHeaderId !== prevProps.dealHeaderId) {
                if(this.props.dealHeaderId > 0){
                    let propertiesC = await getPropertiesForDealHeader(this.props.dealHeaderId, CustomerType);
                    if (propertiesC != null && propertiesC.entityProperties != null) {
                        let addPwdToReports = propertiesC.entityProperties.find(x => x.Description === 'AddPasswordToReports');
                        if(addPwdToReports != null && addPwdToReports.TextValue !== null && addPwdToReports.TextValue.toLowerCase() === 'yes'){
                            addPasswordToReports = true
                            this.setState({addPwdToReports: true})
                        }
                    }
                }
                if (this.props.dealHeaderInfo == null || (this.props.dealHeaderInfo.Email === undefined || this.props.dealHeaderInfo.TraderEmail === undefined)) {
                    getDealHeaderInfo(this.props.dealHeaderId).then(
                        (value) => {
                            if (value != null && value.dealHeaderInfo != null) {
                                let dealHeaderInfo = {};
                                if (value.dealHeaderInfo != null) 
                                {
                                    dealHeaderInfo = value.dealHeaderInfo[0];
                                    this.setState({
                                        dealHeaderId: this.props.dealHeaderId,
                                        dealHeaderInfo: dealHeaderInfo,
                                        email: dealHeaderInfo.Email,
                                        emailChecked: dealHeaderInfo.EmailConfirmations,
                                        traderEmail: dealHeaderInfo.TraderEmail,
                                        language: dealHeaderInfo.PreferredLanguage,
                                        emailDisabled: !this.stringEmptyOrNull(dealHeaderInfo.Email)
                                    }, () => {
                                        this.getCustomerContactList(this.state.dealHeaderInfo);
                                    });
                                }
                            }
                        }
                    );
                } else {
                    this.setState({ dealHeaderId: this.props.dealHeaderId });
                }
            }
        }
    }

    getCustomerContactList = (dealHeaderInfo) =>
    {
        getContactsByCustomer(dealHeaderInfo['Customer ID'],0,0).then(
            (value) => {
                /*
                    httpErrorMessage: "The request is invalid."
                    httpStatusCode: 400

                    contacts: (11) [{
                        Contact ID: 9273
                        ContactType$: "Individual"
                        Email: "m.alves@nexo.com"
                        Main Contact$: false
                        MaxOpenForwardDays$: 0
                        Mobile Phone: ""
                        Name: "Alves, Mellissa"
                        PersonID$: "EA6D1B89-5F84-4324-A83D-1C5905F9151B"
                        Phone: "1234"
                        Status$: "Active"
                    }, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
                    httpErrorMessage: undefined
                    httpStatusCode: 200
                    totalCount: 11
                */
                if (value != undefined) 
                {
                    let areCustomerContacts = false;
                    let errorMessage = 'Could not bring customer contact list.';
                    switch (value.httpStatusCode) 
                    {
                        case 200:
                        {    
                            areCustomerContacts = true;
                            break;
                        }
                        case 400:
                        {
                            if(value.httpErrorMessage !== '')
                            {
                                errorMessage = value.httpErrorMessage;
                            }
                            break;
                        }
                        default:
                        {
                            break;
                        }
                    }

                    if(areCustomerContacts)
                    {
                        let newList = [];
                        let idMain = 0;
                        if(value.contacts != undefined)
                        {
                            newList = value.contacts.length > 0 ? value.contacts: [];
                            newList.forEach(contact => {
                                contact.value = contact['Contact ID'];
                                contact.name = contact.Name + ' - ' + contact['Email'] + ' (' + contact['Mobile Phone'] + ')'

                                if(contact['Main Contact$'])
                                {
                                    idMain = contact['Contact ID'];
                                }
                            });
                        }

                        this.setState({
                            customerContactsList: newList,
                            customerContactSelected: idMain
                        }, () =>{
                            getCustomerByID(dealHeaderInfo['Customer ID']).then(
                                (responseGetCustomerByID) => {
                                    /*
                                    */
                                    if(responseGetCustomerByID !== undefined)
                                    {
                                        let newContactLikeCustomer = {
                                            value           : -1,
                                            'Contact ID'    : -1,
                                            name            : responseGetCustomerByID.Name + ' - ' + responseGetCustomerByID.Email + ' (' + responseGetCustomerByID.MobilePhone + ')',
                                            'Email'         : responseGetCustomerByID.Email,
                                            'Mobile Phone'  : responseGetCustomerByID.MobilePhone,

                                        }
                                        let list = this.state.customerContactsList;
                                        list.unshift(newContactLikeCustomer);
                                        this.setState({
                                            customerContactsList: list,
                                            customerContactSelected: this.state.customerContactSelected === 0 ? -1 : this.state.customerContactSelected
                                        });
                                    }
                                }
                            );
                        });
                    }else
                    {
                        this.setState({
                            showAlert      : true,
                            alertTitle     : 'Error',
                            alertMessage   : errorMessage
                        });
                    }
                }
            }
        );
    }

    componentDidMount() {
        console.log(this.props)
        addPasswordToReports = (window.REACT_APP_ADD_PASSWORD_TO_REPORTS) ? window.REACT_APP_ADD_PASSWORD_TO_REPORTS : false;
        if (this.props.lookUpTables != null) {
            let lookUpTables = this.props.lookUpTables;
            let languages = lookUpTables.filter(x => x.LookUpTableDescription === LookUpTables.Languages)[0];

            languages.lookUpTableDetails.forEach(element => {
                element.value = element.LookUpTableDetail;
                element.name = element.LookUpTableDetail;
            });
            this.setState({listLanguages: languages.lookUpTableDetails})
        }
        if (this.props.dealHeaderInfo != null) {
            this.setState({
                dealHeaderInfo: this.props.dealHeaderInfo,
                email: this.props.dealHeaderInfo.Email,
                emailChecked: this.props.dealHeaderInfo.EmailConfirmations,
                traderEmail: this.props.dealHeaderInfo.TraderEmail,
                language: this.props.dealHeaderInfo.PreferredLanguage,
                emailDisabled: !this.stringEmptyOrNull(this.props.dealHeaderInfo.Email)
            });
        }
        if (this.props.dealHeaderId != null) {
            if (this.props.dealHeaderInfo == null || (this.props.dealHeaderInfo.Email === undefined || this.props.dealHeaderInfo.TraderEmail === undefined)) 
            {
                getDealHeaderInfo(this.props.dealHeaderId).then(
                    (value) => {
                        if (value != null && value.dealHeaderInfo != null) {
                            let dealHeaderInfo = {};
                            if (value.dealHeaderInfo != null) {
                                dealHeaderInfo = value.dealHeaderInfo[0];
                                this.setState({
                                    dealHeaderId: this.props.dealHeaderId,
                                    dealHeaderInfo: dealHeaderInfo,
                                    email: dealHeaderInfo.Email,
                                    emailChecked: dealHeaderInfo.EmailConfirmations,
                                    traderEmail: dealHeaderInfo.TraderEmail,
                                    language: dealHeaderInfo.PreferredLanguage,
                                    emailDisabled: !this.stringEmptyOrNull(dealHeaderInfo.Email)
                                }, () => {
                                    this.getCustomerContactList(this.state.dealHeaderInfo);
                                });
                            }
                        }
                    }
                );
            } else {
                this.setState({ dealHeaderId: this.props.dealHeaderId });
            }
        }
        if (this.props.lookUpTables == null) {
            getLookUpTable('Languages').then(
                (json) => {
                    if (json != null && json.lookUpTables != null) {
                        let languages = json.lookUpTables[0];
                        languages.lookUpTableDetails.forEach(element => {
                            element.value = element.LookUpTableDetail;
                            element.name = element.LookUpTableDetail;
                        });
                        this.setState({ listLanguages: languages.lookUpTableDetails });
                    }
                }
            )
        }
    }

    onCloseDialog = () => {
        this.setState({}, () => this.props.onClose());
    }

    //services
    showConfirmation = () => {
        this.setState({loading: true}, () => {
            getConfirmation(this.state.dealHeaderId).then((value) => {
                this.setState({loading: false})
                if (value !== undefined) {
                    let fileName = 'Deal Confirmation ' + this.state.dealHeaderId + '.pdf';
                    var byteCharacters = atob(value.data);
                    var byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    var bytes = new Uint8Array(byteNumbers);
                    var blob = new Blob([bytes], {
                        type: mime.lookup(fileName)
                    });

                    /*var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();*/

                    let fileList = [{
                        uri     : window.URL.createObjectURL(blob),
                        fileType: 'pdf',
                        fileName: fileName
                    }];

                    this.setState({
                        currentFileName     : fileName,
                        currentFileURLList  : fileList,
                        openPreviewFile     : true
                    });
                }
            })
        })        
    }

    
    showInwardConfirmation = () => {
        this.setState({loading: true}, () => {
            getInwardConfirmation(this.state.dealHeaderId).then((value) => {
                this.setState({loading: false})
                if (value !== undefined) {
                    if(value.Message === undefined){
                        let fileName = 'Inward Funds Confirmation ' + this.state.dealHeaderId + '.pdf';
                        var byteCharacters = atob(value.data);
                        var byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        var bytes = new Uint8Array(byteNumbers);
                        var blob = new Blob([bytes], {
                            type: mime.lookup(fileName)
                        });
    
                        let fileList = [{
                            uri     : window.URL.createObjectURL(blob),
                            fileType: 'pdf',
                            fileName: fileName
                        }];
    
                        this.setState({
                            currentInwardName     : fileName,
                            currentInwardURLList  : fileList,
                            openPreviewInward     : true
                        });
                    } else {
                        this.setState({
                            showAlert      : true,
                            alertTitle     : 'Error',
                            alertMessage   : value.Message
                        });
                    }
                }
            })
        })        
    }

    yesToAlertEmail = () => {
        this.sendConfirmationDirect()
    }

    sendConfirmation = () => {

        var resultValidateFields = this.validateRequiredFields();
        var r1 = resultValidateFields[0];
        var r2 = resultValidateFields[1];

        if (!r1)
        {
            if(r2.length > 0)
            {
                this.setState({
                    showAlert      : true,
                    alertTitle     : 'Error',
                    alertMessage   : 'Please fill all mandatory fields:',
                    messageList    : r2
                });
            }
            return;
        }

        if (this.validateEmailBelongsToCustomer()) 
        {
            if(!this.state.DealConfirmationChecked && !this.state.InwardsFundsConfirmationChecked){
                this.setState({
                    showAlert      : true,
                    alertTitle     : 'Error',
                    alertMessage   : 'You must select a document to send.'
                });
            } else {
                this.sendConfirmationDirect();
            }
        } else {
            this.setState({
                showAlertEmail: true,
                alertTitleEmail: 'Warning',
                alertMessageEmail: 'One or more emails do not belong to this customer. Do you still want to send these emails?'
            });
        }
    }

    sendConfirmationDirect = () => {
        this.setState({
            showAlertEmail: false, alertTitleEmail: '', alertMessageEmail: ''
        });

        if (!this.state.emailChecked && !this.state.additionalEmailChecked && !this.state.traderEmail) 
        {
            this.setState({
                showAlert: true,
                alertTitle: 'Error',
                alertMessage: 'Please select who to send the confirmation to.'
            });
            return;
        }

        let sendTrader = false;
        if(this.state.traderEmailChecked){
            sendTrader = true;
        }

        let sendDealReportByEmailRequest = {
            DealHeaderID: this.state.dealHeaderId,
            Language: this.state.language,
            SendTrader: sendTrader,
        }

        let DealMailInfo = [];
        let confirmationValue = '';

        if(this.state.InwardsFundsConfirmationChecked && this.state.DealConfirmationChecked)
        {
            confirmationValue = DocumentTypes.BOTH_CONFIRMATION
        }
        else if(this.state.InwardsFundsConfirmationChecked)
        {
            confirmationValue = DocumentTypes.INWARD_CONFIRMATION
        }else if(this.state.DealConfirmationChecked)
        {
            confirmationValue = DocumentTypes.CONFIRMATION
        }

        if (this.state.emailChecked) 
        {
            if(addPasswordToReports)
            {
                this.state.customerContactsList.forEach(customerContact => {
                    if(customerContact['Contact ID'] === this.state.customerContactSelected)
                    {
                        DealMailInfo.push({
                            MainInfo    : customerContact.Email, 
                            MobilePhone : customerContact['Mobile Phone'],
                            DocType     : confirmationValue
                        });
                    }
                });
            }else
            {
                DealMailInfo.push({MainInfo: this.state.email, DocType: confirmationValue})
            }
        }
        
        if (this.state.additionalEmailChecked) 
        {
            if(addPasswordToReports)
            {
                DealMailInfo.push({
                    MainInfo    : this.state.additionalEmail, 
                    MobilePhone : this.state.additionalMobileNumber,
                    DocType     : confirmationValue
                });
            }else
            {
                DealMailInfo.push({MainInfo: this.state.additionalEmail, DocType: confirmationValue});
            }
        }

        if(!this.state.emailChecked && !this.state.additionalEmailChecked && this.state.traderEmailChecked)
        {
            sendDealReportByEmailRequest = {
                DealHeaderID: this.state.dealHeaderId,
                Language: this.state.language,
                SendTrader: false,
            }
            DealMailInfo.push({MainInfo: this.state.traderEmail, DocType: confirmationValue});       
        }
        
        /*if (this.state.traderEmailChecked) 
        {
            if(addPasswordToReports)
            {
                DealMailInfo.push({
                    MainInfo    : this.state.traderEmail, 
                    MobilePhone : this.state.additionalMobileNumber,
                    DocType     : confirmationValue
                });
            }else
            {
                DealMailInfo.push({MainInfo: this.state.traderEmail, DocType: confirmationValue});
            }
        }*/

        sendDealReportByEmailRequest.DealMailInfo = DealMailInfo;        

        this.setState({loading: true}, () => {
            sendDealReportByEmailForTraderScreen(sendDealReportByEmailRequest).then((response) => {
                console.log(response)
                this.setState({loading: false});

                if (response.httpStatusCode !== 200) 
                {
                    let errorMessageAux = 'An error occurred while sending the report. Please try again.';
                    switch (response.httpStatusCode) 
                    {
                        case 500:
                        {
                            if(response.Message !== undefined && response.Message !== '')
                            {
                                errorMessageAux = response.Message;
                            }
                            break;
                        }
                        default:
                        {
                            break;
                        }
                    }

                    this.setState({
                        showAlert    : true,
                        alertMessage : errorMessageAux,
                        alertTitle   : 'Error'
                    });
                } else {
                    /*
                        ErrorMessage: null
                        Message: "{\r\n  \"result\": \"Confirmation sent successfully.\"\r\n}"
                        httpErrorMessage: undefined
                        httpStatusCode: 200
                    */

                    this.setState({
                        showAlert: true,
                        alertTitle: ' Success',
                        alertMessage: response.Message//'Confirmation sent successfully.'
                    });
                }
            })
        })
    }

    //validations
    formatValidSelect(valid) {
        return valid ? regularSelectClass : notFilledSelectClass;
    }

    formatValidInput(valid) {
        return valid ? regularInputClass : notFilledInputClass;
    }

    stringEmptyOrNull(str){
        return (str === null || str === '')
    }

    validateEmailBelongsToCustomer() {
        if (this.props.dealHeaderInfo != null && this.props.dealHeaderInfo.EmailsForConfirmations != null && this.props.dealHeaderInfo.EmailsForConfirmations.length > 0) {
            let customerContactEmails = this.props.dealHeaderInfo.EmailsForConfirmations.map(x => x.Email)
            let emails = []

            if (!addPasswordToReports && this.state.emailChecked && !this.stringEmptyOrNull(this.state.email)) {
                emails.push(this.state.email)
            }
    
            if (this.state.additionalEmailChecked && !this.stringEmptyOrNull(this.state.additionalEmail)) {
                emails.push(this.state.additionalEmail)
            }
    
            if (this.state.traderEmailChecked && !this.stringEmptyOrNull(this.state.traderEmail)) {
                emails.push(this.state.traderEmail)
            }

            let invalidEmails = emails.filter(x => !customerContactEmails.includes(x))
            if (invalidEmails.length > 0) {
                return false;
            }
        }
        return true
    }

    validateRequiredFields() 
    {
        let valid = true;
        let validLanguage = true, validEmail = true, validCusomterContactSelected = true, validAdditionalEmail = true, validTraderEmail = true, validAdditionalMobileNumber = true;
        let messages = [];

        if (this.stringEmptyOrNull(this.state.language) || this.state.language.includes('Select')) {
            validLanguage = false;
        }
        
        if (!addPasswordToReports && this.state.emailChecked && this.stringEmptyOrNull(this.state.email)) {
            validEmail = false;
        }

        if(addPasswordToReports && this.state.emailChecked && this.state.customerContactSelected !== undefined)
        {
            if(this.state.customerContactSelected === 0)
            {
                validCusomterContactSelected = false;
            }else
            {
                let ccSelected = null;
                this.state.customerContactsList.forEach(cc => {
                    if(cc['Contact ID'] === this.state.customerContactSelected)
                    {
                        ccSelected = cc;
                    }
                });

                if(ccSelected !== null)
                {
                    if(this.stringEmptyOrNull(ccSelected['Email']))
                    {
                        validCusomterContactSelected = false;
                        messages.push("Contact " + ccSelected.Name + " does not have an Email. Fill in this information first or select another Contact.");
                    }

                    if(this.stringEmptyOrNull(ccSelected['Mobile Phone']))
                    {
                        validCusomterContactSelected = false;
                        messages.push("Contact " + ccSelected.Name + " does not have a Mobile Phone. Fill in this information first or select another Contact.");
                    }
                }
            }
        }

        if (this.state.additionalEmailChecked && this.stringEmptyOrNull(this.state.additionalEmail)) {
            validAdditionalEmail = false;
        }else
        {
            if(this.state.additionalEmailChecked && !validateEmail2(this.state.additionalEmail))
            {
                validAdditionalEmail = false;
                messages.push('Enter a valir Additional Email');
            }
        }

        if (this.state.traderEmailChecked && this.stringEmptyOrNull(this.state.traderEmail)) {
            validTraderEmail = false;
        }else
        {
            if(this.state.traderEmailChecked && !validateEmail2(this.state.traderEmail))
            {
                validTraderEmail = false;
                messages.push('Enter a valir Trader Email');
            }
        }

        if (addPasswordToReports && this.state.additionalEmailChecked && this.stringEmptyOrNull(this.state.additionalMobileNumber)) {
            validAdditionalMobileNumber = false;
        }

        valid = validLanguage && validEmail && validCusomterContactSelected &&validAdditionalEmail && validTraderEmail && validAdditionalMobileNumber;

        this.setState({
            validations: {
                ...this.state.validations,
                language: validLanguage,
                email: addPasswordToReports? validCusomterContactSelected : validEmail,
                additionalEmail: validAdditionalEmail,
                traderEmail: validTraderEmail,
                additionalMobileNumber: validAdditionalMobileNumber
            }
        });

        return [valid, messages];
    }

    //events

    handleLanguage(value){
        if (typeof value !== undefined && value !== undefined) 
        {
            switch (typeof value) {
                case 'object':
                {
                    this.setState({language: value !== null ? value.value : ''});
                    break;
                }
                case 'string':
                {
                    this.setState({language: value !== null ? value : ''});
                    break;
                }
            }
        }
    }

    handleCustomerContact = (contact) =>{
        /*
            Contact ID: 9363
            ContactType$: "Individual"
            Email: "hugobullont@gmail.com"
            Main Contact$: false
            MaxOpenForwardDays$: 0
            Mobile Phone: "888888"
            Name: "Hugo Bullon"
            PersonID$: "9E6307AB-E807-4421-851B-BCFDD382158C"
            Phone: "999999"
            Status$: "Active"
            controlID: "form-dealconfirmation-customercontact"
            name: "Hugo Bullon - hugobullont@gmail.com (888888)"
            value: "9363"
        */
        if (contact !== undefined && typeof(contact) === 'object')
        {
            this.setState({
                customerContactSelected: contact['Contact ID'],
                validations: { 
                    ...this.state.validations, 
                    customerContactSelected: true,
                }
            });
        }
    }

    handleEmailChecked = (event) => {
        let checked = event.target.checked;
        this.setState({emailChecked: checked})
    }

    handleEmail = (event) => {
        this.setState({email: event.target.value});
    }

    handleAdditionalEmailChecked = (event) => {
        let checked = event.target.checked;
        this.setState({
            additionalEmailDisabled: !checked, 
            additionalEmail: '', 
            additionalMobileNumber: '',
            additionalEmailChecked: checked,
            validations: { 
                ...this.state.validations, 
                additionalMobileNumber: !checked? true: this.state.validations.additionalMobileNumber,
                additionalEmail: !checked? true: this.state.validations.additionalEmail
            }
        });
    }

    handleAdditionalEmail = (event) => {
        this.setState({additionalEmail: event.target.value, validations: { ...this.state.validations, additionalEmail: true }});
    }

    handleTraderEmailChecked = (event) => {
        let checked = event.target.checked;
        this.setState({ traderEmailChecked: checked });
    }

    handleTraderEmail = (event) => {
        this.setState({traderEmail: event.target.value});
    }

    //alerts
    closeAlert = () => {
        this.setState({showAlert: false, alertMessage: '', alertTitle: '', messageList: []})
    }

    closeAlertEmail = () => {
        this.setState({showAlertEmail: false, alertMessageEmail: '', alertTitleEmail: ''})
    }

    handleUpdateInwardsFundsConfirmationCheckedChanged = (event) => 
    {
        this.setState({
            InwardsFundsConfirmationChecked: event.target.checked
        });
    }

    handleUpdateDealConfirmationCheckedChanged = (event) => 
    {
        this.setState({
            DealConfirmationChecked: event.target.checked
        });
    }

    onClosePreviewFile = () =>
    {
        this.setState({
            currentFileName     : '',
            currentFileURLList  : [],
            openPreviewFile     : false,
        })
    }
    
    onClosePreviewInward = () =>
    {
        this.setState({
            currentInwardName     : '',
            currentInwardURLList  : [],
            openPreviewInward     : false,
        })
    }

    onchangeAdditionalMobileNumber = (mobilePhone, data, event, formattedValue) => {
        this.setState({
            additionalMobileNumber: mobilePhone,
            validations: { ...this.state.validations, additionalMobileNumber: true },
        });
    }

    render() { 
        return(
            <Dialog 
                    open        = {this.props.open} 
                    onClose     = {this.props.onCloseDialog}
                    fullWidth   = {true}
                    maxWidth    = {false}
                    style       = {{
                        width: '50%',
                        margin: 'auto'
                    }}
                >
                    <DialogTitle 
                        id="customized-dialog-gwlatr-title"
                        onClose={this.onCloseDialog}
                    >
                        {this.state.title}
                    </DialogTitle>
                    <DialogContent dividers style={{paddingLeft:24, overflowY: 'visible'}}>
                        <div className="uk-grid">
                            {/*Line1*/}
                            <div className="uk-width-1-3">
                                <label className="uk-form-label">Language:</label>
                                <DynamicSelect className={this.formatValidSelect(this.state.validations.language)} id="form-dealconfirmation-language" data={this.state.listLanguages} 
                                    objValue={{value: this.state.language}} getValue={this.handleLanguage.bind(this)} />
                            </div>
                            <div className="uk-width-1-3"></div>
                            <div className="uk-width-1-3"></div>
                            
                            {/*Line2*/}
                            <div className={addPasswordToReports ? "uk-width-1-2" : "uk-width-1-2"} style={{paddingTop: 10}}>                        
                                <input className="uk-checkbox  uk-margin-right" type="checkbox" id="form-dealconfirmation-emailcheck" onChange={this.handleEmailChecked} 
                                    checked={this.state.emailChecked}/>
                                <label className="uk-form-label" >Customer Email</label>
                                {!addPasswordToReports && <input 
                                    className   = {this.formatValidInput(this.state.validations.email)} 
                                    type        = "text" 
                                    id          = "form-dealconfirmation-email" 
                                    value       = {this.state.email} 
                                    onChange    = {this.handleEmail} 
                                    disabled    = {this.state.emailDisabled}
                                />}
                                {addPasswordToReports && <DynamicSelect 
                                    className   = {this.formatValidSelect(this.state.validations.email)} 
                                    id          = "form-dealconfirmation-customercontact" 
                                    data        = {this.state.customerContactsList} 
                                    objValue    = {{value: this.state.customerContactSelected}} 
                                    getValue    = {this.handleCustomerContact}
                                    disabled    = {!this.state.emailChecked}
                                />}
                            </div>

                            <div className={addPasswordToReports ? "uk-width-1-2" : "uk-width-1-2"} style={{paddingTop: 10}}>                        
                                <input className="uk-checkbox uk-margin-right" type="checkbox" id="form-dealconfirmation-additionalEmailCheck" onChange={this.handleAdditionalEmailChecked}/>
                                <label className="uk-form-label" >Additional Email</label>
                                <div style={{display:'flex', flexDirection:'row'}}>
                                    <div style={{width:addPasswordToReports? '56%' : '100%', paddingRight: 10}}>
                                        <input 
                                            className={this.formatValidInput(this.state.validations.additionalEmail)} 
                                            type="text" id="form-dealconfirmation-additionalemail" 
                                            value={this.state.additionalEmail} 
                                            onChange={this.handleAdditionalEmail} 
                                            disabled={this.state.additionalEmailDisabled}
                                        />
                                    </div>
                                    {addPasswordToReports && <div style={{width:'44%'}}>
                                        <PhoneInput
                                            inputProps  = {{
                                                name        : 'phone',
                                                required    : true,
                                                autoFocus   : true
                                            }}
                                            enableSearch        = {true}
                                            disableSearchIcon   = {true}
                                            containerStyle      = {{
                                                height: 30
                                            }}
                                            inputClass  = {this.formatValidInput(this.state.validations.additionalMobileNumber)}
                                            inputStyle  = {{
                                                height: 30,
                                                borderRadius: 0
                                            }}
                                            buttonStyle = {{
                                                borderColor: this.state.validations.additionalMobileNumber ? '#CACACA': 'red'
                                            }}
                                            disabled    = {this.state.additionalEmailDisabled}
                                            placeholder = 'Enter a Mobile Number'
                                            autoFormat
                                            copyNumbersOnly     = {true}
                                            countryCodeEditable = {true}
                                            value               = {this.state.additionalMobileNumber}
                                            onChange            = {this.onchangeAdditionalMobileNumber}
                                            preferredCountries  = {['gb']}
                                            searchPlaceholder   = 'Search a country'
                                            autocompleteSearch

                                        />
                                    </div>}
                                </div>
                            </div>

                            {/*Line3*/}
                            <div className={addPasswordToReports ? "uk-width-1-2" : "uk-width-1-2"} style={{paddingTop: 10}}>          
                                <input className="uk-checkbox uk-margin-right" type="checkbox" id="form-dealconfirmation-traderEmailCheck" onChange={this.handleTraderEmailChecked}/> 
                                <label className="uk-form-label" >Trader Email</label>
                                <div style={{display:'flex', flexDirection:'row'}}>
                                    <div style={{width:addPasswordToReports? '56%' : '100%', paddingRight: 10}}>
                                        <input 
                                            className={this.formatValidInput(this.state.validations.traderEmail)} 
                                            type="text" id="form-dealconfirmation-traderemail" 
                                            value={this.state.traderEmail} 
                                            onChange={this.handleTraderEmail} 
                                            disabled={this.state.traderEmailDisabled}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={addPasswordToReports ? "uk-width-1-2" : "uk-width-1-2"} style={{paddingTop: 10}}>                     
                                <label className="uk-form-label" ></label>
                                <label className="uk-form-label" ></label>
                            </div>

                            <div 
                                className="uk-width-1-2"
                                style={{paddingTop: 10, margin:'auto'}}
                            >
                                <div style={{display:'flex'}}>
                                    <input
                                            style       = {{marginBlock:'auto'}}
                                            className   = "uk-checkbox" 
                                            value       = {this.state.DealConfirmationChecked} 
                                            checked     = {this.state.DealConfirmationChecked} 
                                            onChange    = {this.handleUpdateDealConfirmationCheckedChanged} 
                                            type        = "checkbox"
                                    />
                                    <label style={{fontSize: 'smaller'}}>Include Deal Confirmation</label>
                                </div>

                                {this.props.showIncludeInwardConfirmation && <div
                                    style={{display:'flex'}}
                                >
                                    <input
                                            style       = {{marginBlock:'auto'}}
                                            className   = "uk-checkbox" 
                                            value       = {this.state.InwardsFundsConfirmationChecked} 
                                            checked     = {this.state.InwardsFundsConfirmationChecked} 
                                            onChange    = {this.handleUpdateInwardsFundsConfirmationCheckedChanged} 
                                            type        = "checkbox"
                                    />
                                    <label style={{fontSize: 'smaller'}}>Include Inwards Funds Confirmation</label>
                                </div>}

                            </div>
                            <div className="uk-width-1-2"></div>
                            
                            <Divider/>

                            {/*Line4*/}
                            <div className="uk-width-1-1" style={{paddingTop: 2, marginBottom:0}}>
                                <button 
                                    className   = "uk-button uk-button-default uk-button-green" 
                                    type        = "button" 
                                    onClick     = {this.sendConfirmation}
                                >Send Confirmation</button>
                                <button 
                                    className   = "uk-button uk-button-green" 
                                    type        = "button" 
                                    onClick     = {this.showConfirmation}
                                >View Deal</button>
                                <button hidden={!this.state.InwardsFundsConfirmationChecked}
                                    className   = "uk-button uk-button-green" 
                                    type        = "button" 
                                    onClick     = {this.showInwardConfirmation}
                                >View Inward</button>
                                <button 
                                    className="uk-button uk-button-green uk-float-right" 
                                    type="button" 
                                    onClick={this.onCloseDialog}
                                >close</button>
                            </div>
                        </div>
                    </DialogContent>
                    <Dialog 
                        open        = {this.state.openPreviewFile} 
                        onClose     = {this.onClosePreviewFile}
                        fullWidth   = {this.state.fullWidthPreviewFile}
                        maxWidth    = {this.state.maxWidthPreviewFile}
                    >
                        <DialogTitle id="current-attachment-dialog-title" onClose={this.onClosePreviewFile}>
                            {this.state.currentFileName}
                        </DialogTitle>
                        <DialogContent dividers style={{padding: 0}}>      
                           
                                {/*<iframe 
                                    src         = {this.state.currentFileURL}
                                    scrolling   = 'yes'
                                    style       = {{
                                        border      : 'none',
                                        width       : '100%',
                                        height      : '400px',
                                        textAlign   : 'center',
                                    }}
                                >
                                </iframe>*/}
                            <DocViewer
                                pluginRenderers = {DocViewerRenderers} 
                                documents       = {this.state.currentFileURLList}
                                config          = {{
                                    header: {
                                        disableHeader   : true,
                                        disableFileName : true,
                                        retainURLParams : false
                                    }
                                }} 
                            />
                            
                        </DialogContent>
                    </Dialog>
                    <Dialog 
                        open        = {this.state.openPreviewInward} 
                        onClose     = {this.onClosePreviewInward}
                        fullWidth   = {this.state.fullWidthPreviewFile}
                        maxWidth    = {this.state.maxWidthPreviewFile}
                    >
                        <DialogTitle id="current-attachment-dialog-title" onClose={this.onClosePreviewInward}>
                            {this.state.currentInwardName}
                        </DialogTitle>
                        <DialogContent dividers style={{padding: 0}}>    
                            <DocViewer
                                pluginRenderers = {DocViewerRenderers} 
                                documents       = {this.state.currentInwardURLList}
                                config          = {{
                                    header: {
                                        disableHeader   : true,
                                        disableFileName : true,
                                        retainURLParams : false
                                    }
                                }} 
                            />
                            
                        </DialogContent>
                    </Dialog>
                    <AlertBox 
                        open    = {this.state.showAlert} 
                        onClose = {this.closeAlert} 
                        type    = "Ok" 
                        title   = {this.state.alertTitle} 
                        message = {this.state.alertMessage} 
                        okClick = {this.closeAlert}
                        messageBoldList = {this.state.messageList}
                    />

                    <AlertBox 
                        open    = {this.state.showAlertEmail} 
                        onClose = {this.closeAlertEmail} 
                        type    = "Yes/No" 
                        title   = {this.state.alertTitleEmail} 
                        message = {this.state.alertMessageEmail} 
                        noClick = {this.closeAlertEmail} 
                        yesClick= {this.sendConfirmationDirect}
                    />

                    <LoadingBox loading={this.state.loading}/>
                </Dialog>
        );        
    }
}